import { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ChangeEmailCard() {
  const { user, refreshUser } = useAuth();
  const [form, setForm] = useState({ new_email: "", password: "", code: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-email", form);
      toast.success(`${data.message} : ${data.email}`);
      setForm({ new_email: "", password: "", code: "" });
      refreshUser();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Modification impossible");
    } finally {
      setBusy(false);
    }
  };

  const input = "mt-1 w-full rounded-xl border border-amber-900/20 bg-cream px-4 py-2.5 text-sm outline-none focus:border-amber-deep";
  return (
    <form data-testid="change-email-form" onSubmit={submit} className="space-y-3 rounded-2xl border border-amber-800/15 bg-white p-6 shadow-sm">
      <h2 className="flex items-center gap-2 font-serif text-xl font-semibold text-bark"><Mail size={18} className="text-honey" /> Changer l'adresse e-mail de connexion</h2>
      <p className="text-sm text-bark-soft">Adresse actuelle : <strong data-testid="change-email-current">{user?.email}</strong></p>
      <label className="block text-sm font-medium text-bark">Nouvelle adresse e-mail
        <input data-testid="change-email-new" type="email" required autoComplete="email" value={form.new_email} onChange={set("new_email")} className={input} />
      </label>
      <label className="block text-sm font-medium text-bark">Mot de passe actuel
        <input data-testid="change-email-password" type="password" required autoComplete="current-password" value={form.password} onChange={set("password")} className={input} />
      </label>
      <label className="block text-sm font-medium text-bark">Code 2FA (application d'authentification)
        <input data-testid="change-email-code" inputMode="numeric" required maxLength={6} value={form.code} onChange={set("code")} className={input} />
      </label>
      <button data-testid="change-email-submit" disabled={busy} className="flex items-center gap-2 rounded-full bg-amber-deep px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-honey disabled:opacity-60">
        {busy && <Loader2 size={15} className="animate-spin" />} Enregistrer la nouvelle adresse
      </button>
    </form>
  );
}
